import { getStrapi } from '../strapi/getStrapi';
import {
  AllCashbackItems,
  StrapiAllCashbackItemsResponse,
} from '../strapi/types';
import { BlogEndpoints } from '../types';

const Query = `
  query GetAllCashbackItems {
    cashbacks {
      data {
        attributes {
              modalContent {
                title
                tip
              }
              faqitems {
                answer
                question
          }
        }
      } 
    }
  }
`;

function mapCashbackItemsResponse(
  response?: StrapiAllCashbackItemsResponse
): AllCashbackItems {
  if (
    !response ||
    !response?.cashbacks.data ||
    !(response.cashbacks?.data?.length > 0)
  ) {
    return { cashbackItems: [], modalContent: {} };
  }

  return {
    cashbackItems: response.cashbacks?.data?.[0].attributes.faqitems,
    modalContent: response.cashbacks?.data?.[0].attributes.modalContent,
  };
}

export async function getAllCashbackItems() {
  return getStrapi<void, StrapiAllCashbackItemsResponse>({
    id: BlogEndpoints.GetCashbackitems,
    query: Query,
    variables: undefined,
  })
    .then((response) => mapCashbackItemsResponse(response.data))
    .catch(() => []);
}
